class DBFragranceQuiz extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.intro = this.querySelector('[data-screen="intro"]');
    this.questionsWrap = this.querySelector('.db-quiz__questions');
    this.questions = [...this.querySelectorAll('[data-screen="question"]')];
    this.result = this.querySelector('[data-screen="result"]');
    this.progressBar = this.querySelector('.db-quiz__progress span');
    this.progressText = this.querySelector('.db-quiz__progress-text');
    this.stepLabel = this.querySelector('.db-quiz__step-label');
    this.answers = [];
    this.step = 0;
    this.locked = false;

    this.addEventListener('click', (event) => {
      const actionTarget = event.target.closest('[data-action]');
      const action = actionTarget?.dataset.action;
      const choice = event.target.closest('[data-choice]');

      if (action === 'start') this.start();
      if (action === 'back') this.back();
      if (action === 'restart') this.restart();
      if (action === 'copy-code') this.copyCode(actionTarget.dataset.code || 'DEOQUIZ10');
      if (choice) this.selectChoice(choice);
    });

    this.updateProgress(0);
  }

  start() {
    this.preloadResultImages();
    this.intro.hidden = true;
    this.questionsWrap.hidden = false;
    this.step = 0;
    this.showQuestion();
  }

  preloadResultImages() {
    this.querySelectorAll('.db-quiz__result-card img').forEach((image) => {
      image.loading = 'eager';
      image.fetchPriority = 'low';
    });
  }

  selectChoice(button) {
    if (this.locked) return;
    this.locked = true;

    const scores = {
      fortune: Number(button.dataset.fortune || 0),
      unic: Number(button.dataset.unic || 0),
      valen: Number(button.dataset.valen || 0),
      moments: Number(button.dataset.moments || 0),
    };

    this.answers[this.step] = { choice: button.dataset.choice, scores };
    this.questions[this.step].querySelectorAll('[data-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });

    window.setTimeout(() => {
      this.locked = false;
      if (this.step >= this.questions.length - 1) {
        this.showResult();
      } else {
        this.step += 1;
        this.showQuestion();
      }
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
  }

  back() {
    if (this.step === 0) {
      this.questionsWrap.hidden = true;
      this.intro.hidden = false;
      this.updateProgress(0);
      this.intro.querySelector('[data-action="start"]')?.focus();
      return;
    }

    this.step -= 1;
    this.showQuestion();
  }

  restart() {
    this.answers = [];
    this.step = 0;
    this.locked = false;
    this.result.hidden = true;
    this.intro.hidden = false;
    this.questionsWrap.hidden = true;
    this.questions.forEach((question) => {
      question.hidden = Number(question.dataset.step) !== 0;
      question.querySelectorAll('[data-choice]').forEach((item) => item.removeAttribute('aria-pressed'));
    });
    const status = this.querySelector('[data-coupon-status]');
    if (status) status.textContent = '';
    this.updateProgress(0);
    this.intro.querySelector('[data-action="start"]')?.focus();
  }

  showQuestion() {
    this.result.hidden = true;
    this.questions.forEach((question, index) => {
      question.hidden = index !== this.step;
    });
    this.updateProgress(this.step + 1);
    this.stepLabel.textContent = `Pergunta ${this.step + 1}`;
    this.questions[this.step].querySelector('[data-choice]')?.focus();
  }

  showResult() {
    const totals = this.answers.reduce(
      (sum, answer) => ({
        fortune: sum.fortune + answer.scores.fortune,
        unic: sum.unic + answer.scores.unic,
        valen: sum.valen + answer.scores.valen,
        moments: sum.moments + answer.scores.moments,
      }),
      { fortune: 0, unic: 0, valen: 0, moments: 0 },
    );

    const content = {
      fortune: {
        name: 'Kit Fortune Intense',
        reason: 'Suas escolhas pedem presença e intensidade. O kit combina perfume, hidratante e body splash para construir uma assinatura floral ambarada em camadas.',
      },
      unic: {
        name: 'Kit Unic',
        reason: 'Seu momento combina com uma assinatura oriental baunilhada: flores brancas, fundo cremoso e três formas de prolongar uma presença marcante.',
      },
      valen: {
        name: 'Kit Valen',
        reason: 'Você se aproxima de um floral frutado leve e feminino. O kit cria camadas discretas e agradáveis para acompanhar o dia.',
      },
      moments: {
        name: 'Kit My Moments',
        reason: 'Seu perfil pede frescor e versatilidade. O kit combina três camadas florais luminosas para envolver sem invadir.',
      },
    };

    const priority = ['fortune', 'unic', 'valen', 'moments'];
    const available = priority.filter((key) => this.querySelector(`[data-result="${key}"][data-available="true"]`));
    const candidates = available.length ? available : priority;
    const winner = candidates.reduce((best, current) => (totals[current] > totals[best] ? current : best), candidates[0]);

    this.questionsWrap.hidden = true;
    this.result.hidden = false;
    this.result.querySelector('[data-result-name]').textContent = content[winner].name;
    this.result.querySelector('[data-result-reason]').textContent = content[winner].reason;
    this.result.querySelectorAll('[data-result]').forEach((card) => {
      card.hidden = card.dataset.result !== winner;
    });
    this.dataset.result = winner;
    this.stepLabel.textContent = 'Resultado';
    this.updateProgress(this.questions.length);
    const heading = this.result.querySelector('h3');
    heading?.setAttribute('tabindex', '-1');
    heading?.focus();
  }

  async copyCode(code) {
    const status = this.querySelector('[data-coupon-status]');
    try {
      await navigator.clipboard.writeText(code);
    } catch (_) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    if (status) status.textContent = `Código ${code} copiado.`;
  }

  updateProgress(completed) {
    const total = this.questions.length;
    const percent = total ? Math.round((completed / total) * 100) : 0;
    this.progressBar.style.width = `${percent}%`;
    this.progressText.textContent = `${completed} de ${total}`;
  }
}

if (!customElements.get('db-fragrance-quiz')) {
  customElements.define('db-fragrance-quiz', DBFragranceQuiz);
}
